// auth.guard.ts
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { ModalService } from '@services/modal.service';
import { SecurityContextService } from '@services/security_context.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private _modalService: ModalService,
    private securityContextService: SecurityContextService,
    private router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    void route; // mark as intentionally unused

    if (this.securityContextService.isLoggedIn()) {
      return true;
    }

    // Store the intended URL for redirect after login
    this.securityContextService.set('preLoginState', {
      toState: state.url,
      toParams: state.root.queryParams,
    });

    this.router.navigate(['/login']);
    return false;
  }
}
